import { useMemo } from "react";

import type { IOption } from "~/types/option";

import { iconByDashboardSortType, labelByDashboardSortType } from "./constants";
import { DashboardSortType } from "./types";

export const useSortByOptions = (): IOption<DashboardSortType>[] => {
  return useMemo(
    () =>
      Object.values(DashboardSortType).map(
        (sortType): IOption<DashboardSortType> => ({
          label: labelByDashboardSortType[sortType],
          value: sortType,
          icon: iconByDashboardSortType[sortType],
        })
      ),
    []
  );
};
